export default {"src":"/_next/static/media/profile-icon.f69d28ed.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};